export const NOTIFICATION = Symbol('NOTIFICATION');

/**
 * @param {string} message
 * @param {boolean} show
 * @param {number} timeout
 * @param {string} type - plz check REDUX_NOTIFICATION_TYPES
 *
 * @returns {{payload: {show: *, type: *, timeout: *}, type: symbol}}
 */
export const reduxNotificationAction = (message, show, timeout, type) => ({
  type: NOTIFICATION,
  payload: { message, show, timeout, type },
});
